<template>
    <apexchart
        id="line_chart"
        width="100%"
        height="250"
        type="area"
        :options="options"
        :series="series"
    ></apexchart>
</template>
  
  <script setup>
import { ref, onBeforeMount, onMounted } from "vue";
import { useHomeStore } from "@/stores/home";

const homeStore = useHomeStore();

const options = ref({
    chart: {
        id: "line_chart",
        toolbar: {
            show: false,
        },
        zoom: {
            enabled: false,
        },
        parentHeightOffset: 0,
    },
    grid: {
        show: false,
    },
    xaxis: {
        categories: [
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
            "29",
            "30",
            "31",
        ],
        labels: {
            style: {
                colors: "#8f8f8f",
                fontSize: "11px",
            },
        },
        axisBorder: {
            show: false,
        },
    },
    yaxis: {
        labels: {
            formatter: function (value) {
                return Math.abs(value) > 999
                    ? Math.sign(value) * (Math.abs(value) / 1000).toFixed(1) +
                          "k"
                    : Math.sign(value) * Math.abs(value);
            },
            style: {
                colors: ["#8f8f8f"],
                fontSize: "11px",
            },
        },
    },
    dataLabels: {
        enabled: false,
    },
    tooltip: {
        x: {
            formatter: function (value) {
                return "Dia " + value;
            },
        },
        y: {
            formatter: function (value) {
                var amount = value;
                amount = parseFloat(value).toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                });

                return amount;
            },
        },
    },
    legend: {
        show: false,
    },
    stroke: {
        width: 3,
    },
    fill: {
        type: "gradient",
        gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 95, 100],
        },
    },
    colors: ["#28bc6d"],
});

const series = ref([
    {
        name: "Vendas",
        data: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
        ],
    },
]);

const props = defineProps({
    chart: {},

    chart_params: {},

    chartStoreLoaded: {
        required: false,
        default: 'false',
    },
});

onBeforeMount(async () => {
    if(!homeStore.home_chart){
        homeStore.tryHomeChart().then(() => {
            series.value[0].data = homeStore.home_chart.this_month.orders;
        });
    }
});

onMounted(() => {
    if (props.chartStoreLoaded == 'true') {
        series.value[0].data = homeStore.home_chart.this_month.orders;
    }
});

function updateChart() {
    homeStore.tryHomeChart(props.chart_params).then(() => {
        const days = homeStore.home_chart.days;
        const this_month = homeStore.home_chart.this_month.orders;

        options.value.categories = days;

        if (this_month) {
            series.value[0].data = this_month;
        }
    });
}

defineExpose({
    updateChart,
});
</script>

<style scoped>
#line_chart {
    padding: 0px 20px 20px 20px;
}
</style>